import styled from 'styled-components';

export const StyledProblem = styled.section`
  background-color: var(--dark-bg);
  padding: 100px 0;
  position: relative;
  overflow: hidden;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    font-family: Gunar Thin, sans-serif;
    font-weight:bold;
    letter-spacing: 2px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const ProblemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProblemCard = styled.div`
  padding: 30px;
  border-radius: 8px;
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
  border-top: 4px solid var(--primary-color);
  background-color: var(--card-bg);
  color: var(--primary-color);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, var(--primary-color), transparent);
  }

  .icon {
    font-size: 2.5rem;
    color: var(--primary-color);
    margin-bottom: 20px;
  }

  h3 {
    margin-bottom: 15px;
    color: var(--text-color);
  }

  p {
    color: var(--text-color);
    margin-bottom: 0;
  }
`;

export const TechBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: hidden;
`;

export const TechGrid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(255, 107, 0, 0.1) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255, 107, 0, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.2;
  transform: perspective(500px) rotateX(60deg);
  transform-origin: center top;

  @media (max-width: 768px) {
    background-size: 30px 30px;
  }
`;
